import { render, staticRenderFns } from "./LimitOrderForm.vue?vue&type=template&id=71863036&"
import script from "./LimitOrderForm.vue?vue&type=script&lang=js&"
export * from "./LimitOrderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports